export const DEVICE_INFO_CONFIG = {
  company: {
    name: 'Onera B.V.',
    addressLine1: 'Torenallee 42-54',
    addressLine2: '5617 BD',
    cityCountry: 'Eindhoven, The Netherlands',
    phone: '+31 (0) 40 308 2177',
    email: 'info@onerahealth.com',
    website: 'https://onerahealth.com'
  },
  device: {
    appliesToTranslKey: 'deviceInfoAppliesTo',
    releaseDate: '2026-08-24',
    udi: '(01)08720256698470 (10)01.4.3'
  },
  descriptionTranslKey: 'deviceInfoDescription'
};
